// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ece8fdfa","453":"4fc7f8e0","455":"3b8a3b35","857":"c04fba4e","977":"5d6b2f3c"}[chunkId] + ".chunk.js";
};